import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/toast/style/index.tsx